import clsx from 'clsx'

import styles from './modal-overlay.module.scss'

interface IModalOverlayProps {
    isClosing?: boolean
    onClose: () => void
}

export const ModalOverlay = ({
    onClose,
    isClosing = false,
}: IModalOverlayProps): React.ReactNode => {
    return (
        <button
            aria-label='Close modal overlay'
            className={clsx(styles['modal-overlay'], isClosing && styles['modal-overlay_closing'])}
            type='button'
            onClick={onClose}
        />
    )
}
